import { render, staticRenderFns } from "./InvoiceLabourSection.vue?vue&type=template&id=fbb855aa"
import script from "./InvoiceLabourSection.vue?vue&type=script&lang=js"
export * from "./InvoiceLabourSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports